module.exports = __webpack_public_path__ + "6a08414f298cf18d3680b35a72426114.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/trophy-shelf-4.png
// module id = 611
// module chunks = 0